import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {NgbAlert} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-form-message',
templateUrl: './form-message.component.html',
    styleUrls: ['./form-message.component.scss'],
})
export class FormMessageComponent {

    @Input() success: boolean;
    @Input() customSuccessMessage: string;
    @Input() customErrorMessage: string;


}
